// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module__block___GY9QE","wrapper":"styles-module__wrapper___nQ1-Y","close":"styles-module__close___fPCH9"};